import { ApiOption } from '../_foundation/models/base.models';

export class ResetPasswordEditor {
    newPassword: string;
    confirmNewPassword: string;
    id: number;
}

export class KnownUser {
    id: number;
    userId: number;
    username: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    locked: boolean;
    lockoutExpiryTime: Date;
    disabled: boolean;
    roles: Role[] = [];
}

export class KnownUserMapping {
    userId: number;
    username: string;
}

export class Role {
    tag: string;
    name: string;
    permissions: Permission[];
}

export class Permission {
  id: string;
  name: string;
}

export class UserOption extends ApiOption<number> {

}

export class LocalUserAttempt {
    username: string;
    password: string;
}



// WEBPACK FOOTER //
// ./src/models/user-models.ts